import { ChangeDetectorRef, Component, OnInit, Input } from '@angular/core';
import html2pdf from 'html2pdf.js';
import { CommonService } from 'src/app/services/common.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-generate-pdf',
  templateUrl: './generate-pdf.component.html',
  styleUrls: ['./generate-pdf.component.scss'],
})

export class GeneratePdfComponent implements OnInit {
  [x: string]: any;

  vegetationId: string = '';
  parkDetails: any;
  subscriptions: Subscription;
  selectedPark = localStorage.getItem('parkId');
  displayPark = '';
  public imageofQrCode: any;

  @Input() link: string;
  @Input() vegname: string;
  @Input() species: string;
  @Input() displayParkName: string;

  constructor(private commonService: CommonService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    //call base64 iamge
    this.convertImageToBase64(this.link, (dataURL: any) => {
      this.imageofQrCode = dataURL;
      this.cdr.detectChanges();
      if (this.link !== '') {
        setTimeout(() => this.generatePdf(), 300);
      }
    });

    // this.displayParkName = localStorage.getItem('parkname');

  }

  generatePdf() {

    var element = document.getElementById('pdfG');

    if (element) {
      const elementHtml = element.outerHTML;
      localStorage.setItem('pdfElement', elementHtml);

      // Generate the PDF as you were doing before
      var opt = {
        margin: 1,
        filename: `${this.vegname}_QR_Code.pdf`,
        image: { type: 'jpeg' as const, quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, allowTaint: false },
        enableLinks: true,
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' as const },
      };
      html2pdf().from(element).set(opt).save();
    } else {
      console.error('PDF element not found.');
    }
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  convertImageToBase64(imgUrl: string, callback: { (dataURL: any): void; (arg0: string): any }) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      const dataUrl = canvas.toDataURL();
      callback && callback(dataUrl);
      // this.previousImageConvertFile.push({ 'dataUrl': dataUrl, 'imgUrl': imgUrl });
      let filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1); //imgUrl.lastIndexOf("/") + 1;
    };
    image.src = imgUrl;
  }

}
